export const globalConfig = {
    domainName: 'data2go',
    dataSize: 'GB',
    libraries: ['places'],
    allowPhoneNumberLength: 16,
    defaultCurrency: 'usd',
    paymentDefaultCountry: 'US',
    paymentDefaultLabel: 'eSIM Purchase',
    supportEmail: 'support@data2go.mobi',
    contactEmail: 'contact@data2go.mobi',
    salesEmail: 'sales@data2go.mobi',
    phoneNumber:"+31 651683106",
    callUsPhoneNumber:"+44 1223 926858",
    allowNameLength: 20,
    toastDisplayTime: 10000,
    errorToastDisplayTime:10000000,
    deviceInfo: "website",
    isEsimCompatible: false,
    catalogDataAmountperGB: 1000,
    notificationCount:20,
    appStoreLink:"https://apps.apple.com/us/app/data2go/id6733241999",
    playStoreLink:"https://play.google.com/store/apps/details?id=com.mobi.data2go"
}

export const envConfig = process.env

export const responsiveOptions = [
    {
        breakpoint: "1199px",
        numVisible: 3,
        numScroll: 1
    },
    {
        breakpoint: "991px",
        numVisible: 2,
        numScroll: 1
    },
    {
        breakpoint: "767px",
        numVisible: 1,
        numScroll: 1
    }
];
